var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V31H30V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_11",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V31H30V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8749 10.2501V0.666748H30.3333V10.2501H17.8749ZM-0.333496 16.0001V0.666748H12.1249V16.0001H-0.333496ZM17.8749 31.3334V16.0001H30.3333V31.3334H17.8749ZM-0.333496 31.3334V21.7501H12.1249V31.3334H-0.333496ZM1.58317 14.0834H10.2083V2.58342H1.58317V14.0834ZM19.7916 29.4168H28.4166V17.9168H19.7916V29.4168ZM19.7916 8.33342H28.4166V2.58342H19.7916V8.33342ZM1.58317 29.4168H10.2083V23.6668H1.58317V29.4168Z",
    fill: "#2592FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.fff11df6e4c5a86f0991e8c6ee0b0008.svg";
export { ForwardRef as ReactComponent };